// ==================================================================================
// Digital Approval System (DAS) - Request-lifecycle report wrappers
// ==================================================================================
// Thin wrappers binding RequestsReportScreen to each report type. Registered in
// main_layout.tsx as the five "Reports" section screens.
// ==================================================================================

import React from 'react';
import RequestsReportScreen from './RequestsReportScreen';

export const AllRequestsReport: React.FC = () => (
  <RequestsReportScreen
    reportType="All"
    title="All Requests Report"
    description="Every request with status, workflow, and approval details."
  />
);

export const DecidedRequestsReport: React.FC = () => (
  <RequestsReportScreen
    reportType="Decided"
    title="Decided Requests Report"
    description="Approved and rejected requests with decision details. Filter by decision to narrow."
  />
);

export const ReturnedRequestsReport: React.FC = () => (
  <RequestsReportScreen
    reportType="Returned"
    title="Returned Requests Report"
    description="Returned requests with return reasons and workflow details."
  />
);

export const PendingRequestsReport: React.FC = () => (
  <RequestsReportScreen
    reportType="Pending"
    title="Pending Requests Report"
    description="Currently pending requests with pending duration and current stage."
  />
);
